// import React, { useEffect, useLayoutEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
// import Sidebar from "../components/SidebarComponent/Sidebar/Sidebar";
// import Footer from "../components/footer/Footer";
// import AuthNav from "../components/nav/AuthNav";
// import React, { useState } from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined, UnorderedListOutlined, UploadOutlined, UserOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { Avatar, Button, Layout, Menu, MenuProps, Spin, theme } from "antd";
import { useLayoutEffect, useState } from "react";
import AuthNav from "../components/SharedComponent/nav/AuthNav";
import Sidebar from "../components/SharedComponent/SidebarComponent/Sidebar/Sidebar";
import { getSessionData, isUserLoggedIn } from "../services/auth/AuthAPI";
import Footer from "../components/SharedComponent/footer/Footer";
import AuthTab from "../components/SharedComponent/nav/AuthTab";
import { useAppDispatch } from "../redux/useAppDispatch";
import { getEmailfromSession } from "../redux/Transcribe/TranscribeAction";

const { Header, Sider, Content } = Layout;

function AuthLayout(props: any) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  useLayoutEffect(() => {
    const checkUserLogin = async () => {
      try {
        const session = await getSessionData();
        const email = await session.getIdToken().payload.email;

        dispatch(getEmailfromSession(email));
        // setLoading(true);
        const status = await isUserLoggedIn();
        setIsAuthenticated(status);
        setLoading(false);
      } catch (error) {
        setIsAuthenticated(false);
        setLoading(false);
      }
    };
    checkUserLogin();
  }, []);

  if (loading) {
    return (
      <div
        className="app"
        style={{ textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  return isAuthenticated ? (
    <div className="app">
      <AuthNav />
      {/* <AuthTab/> */}
      <Sidebar />
      <Outlet />
      <Footer />
    </div>
  ) : (
    // <Redirect/>
    <Navigate to={"/"} />
  );
}

export default AuthLayout;
